import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Observable} from "rxjs";
import {AttachmentService} from "../../../../services/attachment.service";

@Component({
  selector: 'app-fullscreen-view-attachment',
  templateUrl: './fullscreen-view-attachment.component.html',
  styleUrls: ['./fullscreen-view-attachment.component.scss']
})
export class FullscreenViewAttachmentComponent implements OnInit {

  @Input() documentPath: string
  @Input() documentName: string
  @Output() closeForm = new EventEmitter<boolean>();

  document: Observable<string>

  constructor(
    private attachmentService: AttachmentService
  ) { }

  ngOnInit(): void {
    // this.attachmentService.openFile(this.documentPath).then(data => {
    //   this.document = of(data.data.base64String)
    // })
  }

  close(shouldUpdate) {
    this.closeForm.emit(shouldUpdate);
  }

}
